import type { AxiosInstance } from 'axios';
import type { ApiPaginationResponse, ApiResponse } from '@/types';
import type {
  AuthorityQuery,
  AuthorityResponse,
  CreateAuthorityQuery,
  CreateAuthorityResponse,
  UpdateAuthorityQuery,
  UpdateAuthorityResponse,
  UpdateAuthorityStatusQuery,
  UpdateRoleAuthoritiesQuery
} from '@/types/api/permission.type';

export default function newAuthorityApi(ai: AxiosInstance) {
  function getAuthorityList<D extends AuthorityResponse, R extends ApiPaginationResponse<D>>(params: AuthorityQuery) {
    return ai.get<R>('/api/v2/sysRole/getList', { params });
  }

  function createAuthority<D extends CreateAuthorityResponse, R extends ApiResponse<D>>(params: CreateAuthorityQuery) {
    return ai.post<R>('/api/v2/sysRole/create', params, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  function updateAuthority<D extends UpdateAuthorityResponse, R extends ApiResponse<D>>(params: UpdateAuthorityQuery) {
    return ai.post<R>('/api/v2/sysRole/update', params, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  function updateRoleAuthorities<D extends Record<string, never>, R extends ApiResponse<D>>(params: UpdateRoleAuthoritiesQuery) {
    return ai.post<R>('/api/v2/sysRole/updatePermissions', params);
  }

  function updateAuthorityStatus<D extends Record<string, never>, R extends ApiResponse<D>>(params: UpdateAuthorityStatusQuery) {
    return ai.post<R>('/api/v2/sysRole/updateStatus', params, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  function deleteAuthority<D extends Record<string, never>, R extends ApiResponse<D>>(authorityId: number) {
    return ai.post<R>('/api/v2/sysRole/delete', { authorityId }, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  return {
    getAuthorityList,
    createAuthority,
    updateAuthority,
    deleteAuthority,
    updateRoleAuthorities,
    updateAuthorityStatus
  };
}
